export class Button
{
    constructor(public iconClass?: string, public text?: string, public callback?: () => void)
    {

    }
}